import { render, staticRenderFns } from "./VerificationLink.vue?vue&type=template&id=6df33d86&scoped=true"
import script from "./VerificationLink.vue?vue&type=script&lang=js"
export * from "./VerificationLink.vue?vue&type=script&lang=js"
import style0 from "./VerificationLink.vue?vue&type=style&index=0&id=6df33d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df33d86",
  null
  
)

export default component.exports